var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68472 5.71346L0.5 4.52874L5.02874 0L9.7109 4.68216L8.52618 5.86688L5.86401 3.20471L5.86401 5.8V6.55078L5.86994 6.80005C5.86994 7.70737 6.25344 8.57753 6.93607 9.2191C7.6187 9.86067 8.54455 10.2211 9.50994 10.2211H17.5V11.8H9.50994C8.09899 11.8 6.74583 11.2733 5.74813 10.3356C4.75044 9.3979 4.18994 8.12613 4.18994 6.80005L4.19347 6.55078V5.8V3.20471L1.68472 5.71346Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.c1688dea32c94c2aa8a31869090ae2a8.svg";
export { ForwardRef as ReactComponent };